<div
  class="w-full self-stretch p-6 rounded-lg inline-flex flex-col justify-center items-center gap-3"
>
  <div class="self-stretch flex flex-col justify-start items-center gap-1">
    <div
      class="self-stretch text-center justify-start text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-5"
    >
      {{ 'cockpit.energyInterfaces.list.noResultsTitle' | transloco }}
    </div>
    <div
      class="self-stretch text-center justify-start text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5 max-w-xs m-auto"
    >
      {{ 'cockpit.energyInterfaces.list.noResultsSubtitle' | transloco }}
    </div>
  </div>
  <div class="flex justify-start items-center gap-3">
    <ui-button mode="outlined" (click)="clickReset.emit()">
      <ng-icon slot="start" name="heroXCircle" size="20" class="!block" />
      {{ 'cockpit.energyInterfaces.list.noResultsResetButton' | transloco }}
    </ui-button>
  </div>
</div>
